import React, {useState} from "react";
import {BrowserRouter as Router, Route, Switch} from "react-router-dom";
import Navbar from "./component/general/Navbar";
import Rules from './pages/Rules'
import GameSelector from "./pages/GameSelector";
import Play from "./pages/Play";
import GameOver from "./pages/GameOver";

import "./App.css";


function App() {

  const [livePoint, setLivePoint] = useState(10);

  return (
    <Router>
      <Navbar />
      <div style={{background: 'url("./fondoPagina.png")'}}>
        <Switch>
          <Route exact path='/play' render={(props) => <Play {...props} livePoint={livePoint} setLivePoint={setLivePoint} />} />
          <Route exact path='/rules' component={Rules} />
          <Route exact path='/game-over' render={(props) => <GameOver {...props} setLevel={setLivePoint} />} />
          <Route path='/' render={(props) => <GameSelector {...props} setLevel={setLivePoint} />} />
        </Switch>
      </div>
    </Router>
  );
}

export default App;
